import { useTheme } from "@mui/material"
import { useContextState } from "../../../../../../../../hooks/theme"


const useStyles = () => {
    const { colors } = useContextState()
    const { breakpoints } = useTheme()
    return {
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        emails: {
            maxHeight: "400px",
            overflowY: "auto",
            display: 'flex',

            flexWrap: 'wrap',
            height: '35vh',
            overflow: 'auto',
            [breakpoints.up('lg')]: {
                gap: '2.5%',
            },
            [breakpoints.down('lg')]: {
                gap: '5%',
            },
            //scrollbarWidth: 'none'
        },
        email: {
            backgroundColor: colors.color14,
            //color: colors.color9,
            display: 'flex',
            '&.MuiTypography-root': {
                textAlign: 'start',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
            },
            alignItems: 'center',
            padding: 1,
            '& span': {
                fontWeight: 'bold'
            },
            
            [breakpoints.up('lg')]: {
                width: '23%',
            },
            [breakpoints.down('lg')]: {
                width: '30%',
            },
            maxHeight: '40px',
            marginBottom: 2
        }
    }
}

export { useStyles }
